import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_PHARMACY_PRODUCTS } from "../../action-types/actions";

import i18n from "../../i18n";
export const getPharmacyProducts = createAsyncThunk(
  ACTIONS_GET_PHARMACY_PRODUCTS.get_pharmacy_products,
  async (
    {
      pharmacy_id,
      category_id,
      search = "",
      listing_status = "all",
      page = 1,
      limit = 10,
    },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams();

      if (pharmacy_id) {
        queryParams.append("pharmacy_id", pharmacy_id.toString());
      }

      if (category_id) {
        queryParams.append("category_id", category_id.toString());
      }

      if (search && search.trim()) {
        queryParams.append("search", search.trim());
      }

      if (listing_status && listing_status !== "all") {
        queryParams.append("listing_status", listing_status);
      }

      queryParams.append("page", page.toString());
      queryParams.append("limit", limit.toString());

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyProducts}?${queryParams.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchPharmacyProducts"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingPharmacyProducts");
      // Don't show toast for validation errors
      if (error?.response?.status !== 400) {
        toast.error(errMsg);
      }
      return rejectWithValue(errMsg);
    }
  },
);
